import { useState } from 'react';
import type { CSSProperties } from 'react';
import { STATION_IMAGES } from '@/data/assetManifest';
import type { StationKind } from '@/state/types';

interface StationImageProps {
  kind: StationKind;
  className?: string;
  style?: CSSProperties;
  alt?: string;
  /** Optional override fallback (rendered when no real asset is available). */
  fallback?: React.ReactNode;
}

/**
 * Phase 12.2.3 — Station image with progressive fallback. When no real
 * asset is available (e.g. police kinds), renders nothing or the supplied
 * fallback element.
 */
export function StationImage({
  kind,
  className,
  style,
  alt,
  fallback,
}: StationImageProps) {
  const src = STATION_IMAGES[kind];
  const [errored, setErrored] = useState(false);
  if (!src || errored) {
    return <>{fallback ?? null}</>;
  }
  return (
    <img
      src={src}
      alt={alt ?? `${kind}-Wache`}
      className={className}
      style={style}
      loading="lazy"
      onError={() => setErrored(true)}
    />
  );
}
